import React from "react";
import { FooterWrapper } from "../assets/styles/footer";
import Logo from "../assets/images/logoBottom.png";

const Footer = () => {
    return (
        <FooterWrapper>
            <img src={Logo} alt="logo" />
            {/* <span>Copyright ⓒ Ace Project Inc All Rights Reserved</span>
      <a href="/">개인정보처리방침</a> */}
            <h2>Copyright ⓒ Ace Project Inc. All Rights Reserved.</h2>

            <p>회사명: (주) 에이스프로젝트</p>
            <p>사업자등록번호: 206-86-52416</p>
            <p>주소: 서울특별시 중구 을지로 264 11F 1117호</p>
            <p>전화: 02-6325-3214</p>
            <p>이메일: help@aceproject.co.kr</p>
        </FooterWrapper>
    );
};

export default Footer;
